export default __webpack_public_path__ + "static/media/usdc.f75b5db3.svg";